module.exports = __webpack_public_path__ + "static/patent-47eac14d4c4d2288ee3e64919cc3b061.png";